import React from 'react';
import cn from 'classnames';
import { TabLink as NextNavLink } from '@framework/router/Next/Link';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import Section from '@framework/ui/Pages/Landing/Sections/Section';
import SectionContainer from '@framework/ui/Pages/Landing/Sections/SectionContainer';
import SectionHeader from '@framework/ui/Pages/Landing/Sections/SectionHeader';
import TabsSlider from '@framework/ui/Pages/Landing/Sections/TabsSlider';
import { detailsTabsList } from './tabs';
import styles from './details.module.scss';
import baseStyles from '@/dataroom/ui/components/Landing/researchRoom/tenantResearchRoomStyles.module.scss';
import { IClassNames } from '@framework/ui/Pages/Landing/Sections/TabsSlider/interface';

const classNames: IClassNames = {
  imgClassName: styles.img,
  dotsListClassName: styles.dotsList,
  titleClassName: styles.title,
};

const Details = () => (
  <Section padding="top">
    <SectionContainer size="large">
      <SectionHeader
        title="No one does compliance better than ResearchRoom."
        description={ (
          <>
            We worked closely with Clifford Chance to ensure our platform meets your standards.
            <br />
            ResearchRoom’s deeply integrated checklist and audit workflows
            make checking off compliance requirements easier than ever.
          </>
        ) }
        className={ styles.headerWrapper }
      />
      <TabsSlider content={ detailsTabsList } classNames={ classNames } />
      <div className={ styles.featuresButton }>
        <NextNavLink
          to="/regulations"
          dataTest="exploreOurFeatures"
        >
          <Button
            variant={ ButtonVariantType.action }
            className={ cn(baseStyles.actionButton, styles.exploreButton) }
            title="Learn More About Regulations"
            dataTest="exploreOurFeaturesButton"
          />
        </NextNavLink>
      </div>
    </SectionContainer>

  </Section>
);

export default Details;
